/** Canonical button styles — see .cursor/rules/react-architecture.mdc §6.8.4 */

export function primaryButton(A, { dark = false, height = 36, fontSize = 13, marginTop = 0 } = {}) {
  return {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    height,
    marginTop,
    padding: "0 14px",
    borderRadius: 8,
    border: "none",
    background: A,
    color: "#fff",
    fontSize,
    fontWeight: 700,
    cursor: "pointer",
    flexShrink: 0,
    boxShadow: dark ? `0 4px 14px ${A}44` : height <= 34 ? `0 1px 2px ${A}40` : `0 4px 12px ${A}33`,
  };
}

/** Type-page header "Create …" buttons (34px). */
export function compactPrimaryButton(A) {
  return primaryButton(A, { height: 34, fontSize: 12 });
}

/** Accounts hub toolbar primary (38px). */
export function toolbarPrimaryButton(A) {
  return {
    ...primaryButton(A, { height: 38, fontSize: 13 }),
    padding: "0 16px",
    borderRadius: 10,
    boxShadow: `0 4px 14px ${A}44`,
  };
}

/** Modal footer submit (40px). */
export function modalPrimaryButton(A, dark, saving = false) {
  return {
    ...primaryButton(A, { dark, height: 40, marginTop: 0 }),
    padding: "0 20px",
    opacity: saving ? 0.7 : 1,
    cursor: saving ? "wait" : "pointer",
  };
}

/** Full-width sidebar create CTA (36px). */
export function sidebarPrimaryButton(A, dark) {
  return {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    height: 36,
    borderRadius: 8,
    border: "none",
    background: A,
    color: "#fff",
    fontSize: 13,
    fontWeight: 700,
    cursor: "pointer",
    boxShadow: dark ? "none" : `0 1px 2px ${A}40`,
  };
}

/** Empty-state CTA inside CreateListEmptyState (40px). */
export function emptyStatePrimaryButton(A, dark) {
  return primaryButton(A, { dark, height: 40, marginTop: 20, fontSize: 13 });
}
